
import { withRouter } from 'react-router-dom';
import { Tabs, Tab, Paper } from '@material-ui/core';
import { trackActivity } from '../../../utils/mixpanel';
import { useEffect, useState } from 'react';
const ConfgureTab = ({ tabIndex = 'disclaimer', history, via }) => {

    const utilFlowApproval = JSON.parse(localStorage.getItem("utiFlow_approval"))
    const [inComing, setIncomingValue] = useState(via)

    useEffect(() => {
        if (history?.location.pathname === '/configure/utilization-approval') {
            if (utilFlowApproval) {
                return (history.push(`/configure/utilization-approval`)),
                    setIncomingValue(false)
            } else {
                if (inComing && tabIndex === 'disclaimer') {
                    return (history.push(`/configure/${tabIndex}`)),
                        setIncomingValue(false)
                }
            }
        }
    }, [])

    return (
        <Paper square style={{ marginBottom: '10px' }}>
            <Tabs indicatorColor='primary' value={tabIndex} onChange={(event, newValue) => history.push(`/configure/${newValue}`)} className={'no-margin-tab'}>
                <Tab label='Disclaimer' value="disclaimer" onClick={() => trackActivity('Disclaimer - Tab Clicked', { page_title: 'Configure', event_type: 'Disclaimer Tab', event_desc: 'Clicked on Disclaimer Tab from Configure' })} />
                <Tab label='LLP Template' value="llp" onClick={() => trackActivity('LLP Template - Tab Clicked', { page_title: 'Configure', event_type: ' LLP Template Tab', event_desc: 'Clicked on Template Tab from Configure' })} />
                {utilFlowApproval ? <Tab label='Utilization Approval' value="utilization-approval" onClick={() => trackActivity('Utilization Approval - Tab Clicked', { page_title: 'Configure', event_type: 'Utilization Approval Tab', event_desc: 'Clicked on Utilization Approval Tab from Configure' })} /> : null}
            </Tabs>
        </Paper>
    )
}

export default withRouter(ConfgureTab);